/*
//-------------------------------------------------------
//   Copyright (c) 2024 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     RedirectController
//   Details:    RedirectController store
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// WI3713 24/01/24 JC		New.
//-------------------------------------------------------
*/

import { history } from '../history';

export const redirectRequestType = "REDIRECT_REQUEST";
export const clearRedirectRequestType = "CLEAR_REDIRECT_REQUEST";

const initialState = {
	previousPageArgs: undefined
}; 

export const redirectControllerActions = {
	redirect,
	clearRedirect
};

function redirect(redirectTo, previousPageArgs) {
	return (dispatch) => {
		dispatch(_request(previousPageArgs));

		//push to the correct page
		history.push(redirectTo);
	};

	function _request(previousPageArgs) { return { type: redirectRequestType, previousPageArgs: previousPageArgs }; }
}

function clearRedirect() {
	return (dispatch) => {
		dispatch(_request());
	};

	function _request() { return { type: clearRedirectRequestType}; }
}

export const reducer = (state, action) => {
	state = state || initialState;

	if (action.type === redirectRequestType) {
		return { ...state, previousPageArgs: action.previousPageArgs };
	}

	if (action.type === clearRedirectRequestType) {
		return { ...state, previousPageArgs: undefined };
	}

	return state;
};